import { useUsersByRole } from '@/app/hooks/useUsersByRole'
import { useEffect } from 'react'
import { useInView } from 'react-intersection-observer'

export const useManagersController = () => {
  const { ref, inView } = useInView()

  const {
    data,
    isFetching,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useUsersByRole('MANAGER')

  useEffect(() => {
    if (inView) {
      fetchNextPage()
    }
  }, [fetchNextPage, inView])

  return {
    ref,
    data,
    isFetching,
    isLoading,
    hasNextPage,
    isFetchingNextPage,
  }
}
